import React, { useContext, useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import ProjectsGroup from './ProjectsGroup'
import ProjectsFilterCategories from './ProjectsFilterCategories'
import ProjectsFilterLetters from './ProjectsFilterLetters'
import ProjectsFilterSearch from './ProjectsFilterSearch'

export default function ProjectsArchive ({title, categories, projects, allString, searchLabel, showAllString, showLessString}) {

  const [searchString, setSearchString] = useState('')
  const [letterFilter, setLetterFilter] = useState('')
  const [categoriesFilter, setCategoriesFilter] = useState(0)
  const [allLetters, setAllLetters] = useState([])
  const [readMore, setReadMore] = useState(false)

  let projectSections = 5
  let items = [...projects].map(item => {
    item.value = item.label.toLowerCase()
    return item
  })

  useEffect(() => {
    setAllLetters(items.map(item => item.value.substring(0,1)).filter((item, i, self) => self.indexOf(item) === i))
  },[])


  let lowerCasedSearchString = searchString.toLowerCase()

  if(lowerCasedSearchString.length > 0 ){
    items = items.filter(item => item.value.includes(lowerCasedSearchString))
  }
  if(letterFilter.length === 1){
    items = items.filter(item => item.label.substring(0,1).toLowerCase() === letterFilter)
  }
  if(categoriesFilter > 0){
    items = items.filter(item => item.type.includes(categoriesFilter))
  }
  let sortedItems = {}
  let itemsLength = items.length
  for(let i = 0; i < itemsLength; i++){
    let firstLetter = items[i].value.substring(0,1)
    if(typeof sortedItems[firstLetter] === 'undefined'){
      sortedItems[firstLetter] = []
    }
    sortedItems[firstLetter].push(items[i])
  }

  if(!readMore){
    sortedItems = Object.fromEntries(
      Object.entries(sortedItems).slice(0, projectSections)
    )
  }

  return (
    <section id="projects-archive" className={classNames('mt-projects-archive__content')} >
      <div className={'mt-projects-archive__filter-container'}>
        <div className={'mt-projects-archive__filter-container--filter'}>
          <div className={"mt-projects-archive__filter-container--left"}>
            <h2>{title}</h2>
            <ProjectsFilterCategories
              categories={categories}
              value={categoriesFilter}
              onChange={category => setCategoriesFilter(category)}
            />
          </div>
          <div className={"mt-projects-archive__filter-container--right"}>
            <ProjectsFilterLetters
              letters={allLetters}
              value={letterFilter}
              onChange={letter => setLetterFilter(letter)}
              allString={allString}
            />
            <ProjectsFilterSearch
              placeholder={searchLabel}
              value={searchString}
              onChange={value => setSearchString(value)}
            />
          </div>
        </div>
      </div>
      <div className={'mt-projects-archive__projects'}>
        {Object.keys(sortedItems).map((letter) => <ProjectsGroup key={letter} letter={letter} projects={sortedItems[letter]} />)
        }
      </div>
      {Object.keys(sortedItems).length >= projectSections && (
        <div className={'mt-projects-archive__pagination'}>
          <div className="wp-block-button is-style-black-outline">
            <button className="wp-block-button__link" onClick={() => setReadMore(!readMore)}>
              {!readMore ? showAllString : showLessString}
            </button>
          </div>
        </div>
      )}
    </section>
  )
}

